
var InfiniteScroll = require('infinite-scroll')

function watch() {

	$('[data-like]').click(function (e) {
		e.preventDefault()
		
		var link = $(e.currentTarget)
		var id = parseInt(link.data('like'), 10)
		
		if (link.hasClass('likes')) {
			$.ajax({
				url: '/api/likes/' + id,
				method: 'delete',
			}).done(function() {
				link.removeClass('likes')
			})
		}	else {
			$.ajax({
				url: '/api/likes/' + id,
				method: 'put',
			}).done(function() {
				link.addClass('likes')
			})
		}
	})

	$('[data-trash]').click(function (e) {
		e.preventDefault()
		var $el = $(e.currentTarget)
		var trash = $el.data('trash')
		if (confirm('Are you sure that you want to delete this poster?')) {
			if (confirm('Before you delete it, make sure that you have already upload a new one!')) {
				$.ajax({
					url: '/api/entry/' + trash,
					method: 'delete',
					data: {id: trash}
				}).done(function() {
					$el.parents('.post').hide()
				})
			}
		}
	})
}

$(function() {

	watch()

	$('[data-filter]').on('click', function(e) {
		e.preventDefault()
		$('[data-filter]').removeClass('bg-secondary text-white')
		var filterList = $(e.currentTarget).data('filter')

		$('#filter-list > li').each(function () {
			($(this).data('show') == filterList) ? $(this).collapse('show') : $(this).collapse('hide')
		})

		$(this).addClass('bg-secondary text-white')

		e.stopPropagation()
	})

	$('.filter-remove').on('click', function(e) {
		e.preventDefault()
		$('#filter-list > li').each(function () {
			$(this).collapse('hide')
		})
		$('[data-filter]').removeClass('bg-secondary text-white')
		e.stopPropagation()
	})

	if ($('#filter-bar a.active').length) {
		$('#filtering').collapse('show')
	}

	var infScroll = new InfiniteScroll( '#scroll-page', {
		path: '.pagination_next',
		append: '.post',
		history: false,
	});

	infScroll.on('load', function() {
		if (stButtons.locateElements != undefined) {
			stButtons.locateElements()
		}
		watch()
	})
})
